import * as _ from 'underscore';
import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('daypartingTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      allDayParts: '<',
      dayParting: '<',
      usersTimezone: '<',
      displayDayparting: '@',
      dayPartingPath: '@'
    },
    template: require("../templates/daypartingTargeting.html"),
    controllerAs: '$daypartingTargetingCtrl',
    controller: ['$scope', '$timeout', '$element', function($scope, $timeout, $element) {
      const self = this;
      const bodySelector = $('body');

      this.tooltip = $("select[name*='[budget_timezone]']").val();

      /**
       * Keeps a separate copy of the dayparting values while they're being edited to allow them to be reverted
       * @type {Array<Array<boolean>>}
       */
      this.modalDayParting = Array.from({ length: 7 }, (_v, day) => Array.from( { length: 24 }, (_v, hour) => !!_.get($scope.dayParting, [day, hour], false)));
      /** Keeps a separate copy of the user timezone value to allow it to be reverted */
      this.modalUsersTimezone = false;

      this.targetingButtonOptions = componentHelper.allCustomOptions2();

      this.openDaypartingModalClass = function(allDayParts) {
        return !allDayParts && self.dayParting.length === 0;
      };

      this.dayPartingInputNameFor = function(day, hour) {
        return 'day_parting[' + day + '][' + hour + ']';
      };

      bodySelector.on("click", ".open-dayparting-modal", function() {
        $("#day_parting_modal").modal();
      });

      $('#day_parting_modal #modal_save').click(function() {
        $('#day_parting_modal').modal('hide');

        $timeout(function() {
          $scope.$apply();
        });
      });

      const resetTemporaryModalValues = function() {
        // make a copy of dayParting to allow users to confirm changes before applying them to the form this component is embedded in
        for (let day = 0; day < 7; ++day) {
          for (let hour = 0; hour < 24; ++hour) {
            self.modalDayParting[day][hour] = !!(Array.isArray(self.dayParting) && self.dayParting[day] && self.dayParting[day][hour]);
          }
        }

        self.modalUsersTimezone = self.usersTimezone;

        $timeout(() => { $scope.$apply(); });
      };

      const setAllDayParts = function() {
        $('label[for$="all_day_parts_true"]').click();
      };

      const save = function() {
        const uniqueValues = _.chain(self.modalDayParting).flatten().uniq().value();
        if (uniqueValues.length > 1) {
          self.dayParting = angular.copy(self.modalDayParting);
          self.usersTimezone = self.modalUsersTimezone;
        } else {
          self.dayParting = [];
          resetTemporaryModalValues();
          setAllDayParts();
        }

        const data = {day_parting: JSON.stringify(self.dayParting)};
        $.post(self.dayPartingPath, data, function(resp) {
          $('.dayparting').html(resp);
        });
      };

      const cancel = function() {
        if (_.isEmpty(self.dayParting)) {
          setAllDayParts();
        }
        resetTemporaryModalValues();
      };

      // make this component load the dayparting text which we display under the "All", "Custom", "Edit" buttons
      $('#day_parting_modal #modal_save').click(save);
      $('#day_parting_modal .modal_cancel').click(cancel);

      this.$onInit = function() {
        resetTemporaryModalValues();
      };
    }]
});
